/**
 * Customer Orders UI types — backend rows are mapped here by the page adapter.
 */

export type OrderStatus = 'Confirmed' | 'In Transit' | 'Processing' | 'Delivered' | 'Cancelled';
export type PaymentStatus = 'Paid' | 'Pending' | 'Failed';

export interface CustomerOrder {
  id: string;
  orderNumber: string;
  date: string;
  total: string;
  orderStatus: OrderStatus;
  paymentStatus: PaymentStatus;
}

export const orderStatusOptions: string[] = [
  'All Status',
  'Confirmed',
  'In Transit',
  'Processing',
  'Delivered',
  'Cancelled',
];

export function backendStatusToUi(status: string): OrderStatus {
  switch (status) {
    case 'pending': return 'Processing';
    case 'confirmed': return 'Confirmed';
    case 'shipped': return 'In Transit';
    case 'delivered':
    case 'invoiced': return 'Delivered';
    case 'cancelled': return 'Cancelled';
    default: return 'Processing';
  }
}

export function backendInvoiceStatusToPayment(status: string | null | undefined): PaymentStatus {
  if (!status) return 'Pending';
  if (status === 'paid') return 'Paid';
  if (status === 'overdue') return 'Failed';
  return 'Pending';
}
